import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LookupGroupComponent } from './lookup-group/lookup-group.component';
import { LookupItemComponent } from './lookup-item/lookup-item.component';
import { LookupComponent } from './lookup/lookup.component';
import { LookupsComponent } from './lookups.component';






const routes: Routes = [
 {path :"",component:LookupsComponent ,children:[
   {path:"Lookups",component:LookupComponent},
   {path:"LookupGroups",component:LookupGroupComponent},
   {path:"LookupItems/:id/:nameen/:nameaR",component:LookupItemComponent},
   {path:"", redirectTo: 'Lookups', pathMatch: 'full'},

 
 ]}
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
exports: [RouterModule]
})
export class LookupsRoutingModule { }
